import { Box, Fade } from '@mui/material';
import React from 'react';
import FadeElement from '../FadeElement';
import Loading from '../Loading';
import { useStyles } from './Transition.styles';
const Transition = (props) => {
    const classes = useStyles();
    const { isLoading, hideSpinner, children } = props;
    return (React.createElement(React.Fragment, null,
        !hideSpinner && (React.createElement(Box, { component: 'div', sx: classes.loadingContainer },
            React.createElement(Fade, { in: isLoading, unmountOnExit: true },
                React.createElement(FadeElement, null,
                    React.createElement(Loading, null))))),
        React.createElement(Fade, { in: !isLoading },
            React.createElement(FadeElement, null, children))));
};
export default Transition;
